var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "From Timezone" },
          model: {
            value: _vm.clone.isLeapYear.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isLeapYear, "fromTimezone", $$v)
            },
            expression: "clone.isLeapYear.fromTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "From Format" },
          model: {
            value: _vm.clone.isLeapYear.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isLeapYear, "fromFormat", $$v)
            },
            expression: "clone.isLeapYear.fromFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "From Locale" },
          model: {
            value: _vm.clone.isLeapYear.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isLeapYear, "fromLocale", $$v)
            },
            expression: "clone.isLeapYear.fromLocale",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }